import { Link, useLocation } from "react-router-dom";
import type { ReactNode } from "react";
import type { TenantBranding } from "../types";
import type { MeResponse } from "../api/me";

export interface NavItem {
  id: string;
  label: string;
  to: string;
}

export function FoundryTopBar({
  nav,
  activeId,
  tenantName,
  tenantColor,
}: {
  nav: NavItem[];
  activeId: string;
  tenantName: string;
  tenantColor: string;
}) {
  return (
    <div className="fnd-top">
      <div className="fnd-mark">
        <span className="fnd-mark-glyph" />
        <span>Foundry</span>
        <span className="fnd-mark-sub">reports / console</span>
      </div>
      <div className="fnd-nav">
        {nav.map((item) => (
          <Link
            key={item.id}
            to={item.to}
            className={"fnd-nav-item" + (item.id === activeId ? " active" : "")}
          >
            {item.label}
          </Link>
        ))}
      </div>
      <div className="fnd-tenant">
        <span className="fnd-tenant-dot" style={{ background: tenantColor }} />
        <span>{tenantName}</span>
      </div>
    </div>
  );
}

export function VentureTopBar({
  branding,
  me,
  grantedPages,
  activePageId,
  isAdmin = false,
}: {
  branding: TenantBranding;
  me: MeResponse;
  grantedPages: { id: number; name: string }[];
  activePageId: number | null;
  isAdmin?: boolean;
}) {
  const loc = useLocation();
  const onHub = loc.pathname === "/" || loc.pathname === "";
  return (
    <div className="vt-top">
      <Link to="/" className="vt-brand">
        {branding.logo_url ? (
          <img src={branding.logo_url} alt="" className="vt-logo" />
        ) : (
          <span className="vt-logo-glyph" />
        )}
        <span className="vt-brand-name">{branding.application_name}</span>
      </Link>
      <div className="vt-nav">
        <Link to="/" className={"vt-nav-item" + (onHub ? " active" : "")}>
          Home
        </Link>
        {grantedPages.map((p) => (
          <Link
            key={p.id}
            to={`/page/${p.id}`}
            className={"vt-nav-item" + (activePageId === p.id ? " active" : "")}
          >
            {p.name}
          </Link>
        ))}
      </div>
      <div className="vt-user">
        {isAdmin && (
          <Link to="/admin" className="vt-admin-link" title="Operator console">
            ⚙ Admin
          </Link>
        )}
        <span>{me.name ?? me.email}</span>
      </div>
    </div>
  );
}

export function PageHeader({
  eyebrow,
  title,
  children,
}: {
  eyebrow?: string;
  title: string;
  children?: ReactNode;
}) {
  return (
    <div className="pg-hd">
      {eyebrow && <div className="pg-eyebrow">{eyebrow}</div>}
      <div className="pg-hd-row">
        <h1 className="pg-title">{title}</h1>
        <div className="pg-hd-actions">{children}</div>
      </div>
    </div>
  );
}
